export default __webpack_public_path__ + "static/media/background-2.c8e32cf4.jpg";